var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.29981C1 1.74752 1.44772 1.2998 2 1.2998H20C20.5523 1.2998 21 1.74752 21 2.2998V24.2998C21 24.8521 20.5523 25.2998 20 25.2998H2C1.44772 25.2998 1 24.8521 1 24.2998V2.29981ZM2 1.7998C1.72386 1.7998 1.5 2.02366 1.5 2.29981V24.2998C1.5 24.5759 1.72386 24.7998 2 24.7998H20C20.2761 24.7998 20.5 24.5759 20.5 24.2998V2.2998C20.5 2.02366 20.2761 1.7998 20 1.7998H2Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.2998H11V6.7998H18V7.2998Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.2998H11V10.7998H15V11.2998Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15.2998H11V14.7998H18V15.2998Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 19.2998H11V18.7998H14V19.2998Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8.2998C9 9.40437 8.10457 10.2998 7 10.2998C5.89543 10.2998 5 9.40437 5 8.2998C5 7.19524 5.89543 6.2998 7 6.2998C8.10457 6.2998 9 7.19524 9 8.2998ZM7 9.7998C7.82843 9.7998 8.5 9.12823 8.5 8.2998C8.5 7.47138 7.82843 6.7998 7 6.7998C6.17157 6.7998 5.5 7.47138 5.5 8.2998C5.5 9.12823 6.17157 9.7998 7 9.7998Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8361 11.6161C5.41535 11.26 6.17639 11.0498 7 11.0498C7.87093 11.0498 8.67068 11.2847 9.25999 11.6776C9.48063 11.8247 9.675 11.9966 9.83179 12.1889C9.9301 12.3095 10.0136 12.4381 10.0796 12.5736C10.1153 12.647 10.1459 12.7225 10.1709 12.7998C10.1978 12.8832 10.2182 12.9688 10.2316 13.0564C10.2437 13.136 10.25 13.2172 10.25 13.2998H9.75C9.75 12.8576 9.48141 12.4261 8.98265 12.0936C8.92059 12.0522 8.85535 12.0127 8.78716 11.9752C8.30982 11.7128 7.68773 11.5498 7 11.5498C6.14913 11.5498 5.40016 11.7991 4.90068 12.1764C4.52936 12.4568 4.30967 12.7953 4.26055 13.1479C4.25354 13.1983 4.25 13.249 4.25 13.2998H3.75L3.75 13.2982C3.75017 13.1253 3.77787 12.9586 3.8292 12.7998C3.95794 12.4014 4.23529 12.0524 4.59932 11.7774C4.6743 11.7208 4.75335 11.6669 4.8361 11.6161Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 24.2998L23 2.2998L23.5 2.2998L23.5 24.2998L23 24.2998Z",
    fill: "#2D2943"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 13.2998,
    width: 6.5,
    height: 0.5,
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/applications.e05f3db6.svg";
export { ForwardRef as ReactComponent };